<template>
  <v-expansion-panels class="report-register-filter" style="z-index: 5">
    <v-expansion-panel>
      <v-expansion-panel-header @click="getHeightTable()">Tìm kiếm báo cáo theo ngày</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
          class="ma-0 overflow-visible"
          outlined
        >
          <validation-observer v-slot="{ handleSubmit }">
            <v-list-item class="pa-0" three-line>
              <v-list-item-content class="overflow-visible pa-0">
                <v-row>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="filterForm.contactSourcesId"
                      :items="contactSources"
                      item-text="name"
                      item-value="id"
                      label="Nguồn khách hàng"
                      placeholder="Chọn nguồn khách hàng"
                      color="primary"
                      value=''
                      clearable
                      multiple
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-select
                      v-model="filterForm.productGroupsId"
                      :items="productGroups"
                      item-text="name"
                      item-value="id"
                      label="Nhóm sản phẩm"
                      placeholder="Chọn nhóm sản phẩm"
                      color="primary"
                      value=''
                      clearable
                      multiple
                    />
                  </v-col>
                  
                  <v-col cols="12" md="4">
                    <validation-provider
                      name="Chọn ngày"
                      v-slot="{ errors }"
                      rules="required"
                    >
                      <common-range-picker
                        v-model="selectRange"
                        :clearable="true"
                        :aLight="'left'"
                        :defaultRange="defaultRange"
                        @change-date-range="changeDateRange"
                      />
                      <div class="v-text-field__details mt-1">
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{ errors[0] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </validation-provider>
                  </v-col>
                </v-row>
                <div class="text-center mb-4">
                  <v-btn
                    class="primary mx-0"
                    @click.prevent="handleSubmit(searchReport);"
                  >
                    <v-icon>mdi-magnify</v-icon>Tìm kiếm
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-list-item>
          </validation-observer>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>

  import TokenService from '@/helpers/token';
  import * as moment from 'moment'

  export default {
    props: {
      filterForm: {
        default: () => ({}),
      },
      contactSources: {
        type: Array,
        default: () => []
      },
      productGroups: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        defaultRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        },
        selectRange: [{
          startDate: moment().format('YYYY-MM-DD 00:00:00'),
          endDate: moment().format('YYYY-MM-DD 23:59:59'),
        }],
      }
    },
    created () {
      this.searchReport()
    },
    methods: {
      searchReport () {
        Bus.$emit('contact-register-report-filter', this.filterForm)
      },

      changeDateRange (dateRange) {
        this.filterForm.dateRange = dateRange
        this.selectRange = dateRange
      },

      getHeightTable() {
        setTimeout(() => {
          this.$emit('getHeightTable')
        }, 300)
      }
    }
  }
</script>
